import { TEACHER_PORTAL_SCHEDULE } from '../../../api/endpoints';
import request from '../../../api/request';

export const getTeacherSchedule = () => {
  const url = TEACHER_PORTAL_SCHEDULE.BASE;
  return request<any>(url, {
    method: 'get',
  });
};
